
import Vue from 'vue'
import * as Api from '@/api/PartyIdentityUserApi'
import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'
import { Alert } from '@/components'
import { SaveButton } from '@/components/buttons'
import { Textbox } from '@/components/formGroups'

export default Vue.extend({
   name: 'SetPassword',
   props: { schoolId: String, editingItem: Object as () => PartyIdentityUserDto },
   data() {
      return {
         newPassword: '',
         processing: false,
         processed: false,
      }
   },
   computed: {
      canProcess(): boolean {
         return this.newPassword.length >= 6
      },
   },
   methods: {
      async action() {
         this.processing = true
         try {
            await Api.setUserPassword(this.editingItem.Id, this.newPassword)
            this.processing = false
            this.processed = true
         } catch {
            this.processing = false
         }
      },
   },
   components: {
      Alert,
      SaveButton,
      Textbox,
   },
})
